import ButtonsControlGroup from './buttonsControlGroup';

export default ButtonsControlGroup;
